import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import * as ProductDetailSelectors from "@/redux/modules/value/productDetail/productDetail.selectors";

type TriggerProps = RequireChildrenFor<{}>;

const Trigger = ({ children }: TriggerProps) => {
    const stickyOrderButton = useSelector(
        ProductDetailSelectors.getStickyOrderButton
    );

    return (
        <div
            className={cn(
                "tw:fixed tw:bottom-0 tw:left-0 tw:md:left-auto tw:right-0 tw:md:mx-8",
                "tw:bg-background tw:md:bg-none tw:p-2 tw:md:p-0",
                "tw:layer-overlay/[0]",
                {
                    "tw:left-1/2 tw:md:left-auto": stickyOrderButton
                }
            )}
        >
            {children}
        </div>
    );
};

export { Trigger };
